import { render, staticRenderFns } from "./creatCdkey.vue?vue&type=template&id=2e437505&scoped=true"
import script from "./creatCdkey.vue?vue&type=script&setup=true&lang=js"
export * from "./creatCdkey.vue?vue&type=script&setup=true&lang=js"
import style0 from "./creatCdkey.vue?vue&type=style&index=0&id=2e437505&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e437505",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\XM\\QD\\yangzhou\\merchant-admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2e437505')) {
      api.createRecord('2e437505', component.options)
    } else {
      api.reload('2e437505', component.options)
    }
    module.hot.accept("./creatCdkey.vue?vue&type=template&id=2e437505&scoped=true", function () {
      api.rerender('2e437505', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/canteen/cdkey/creatCdkey.vue"
export default component.exports